import { Maybe } from '@acme/core'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type State = {
    progresso: Maybe<number>
    state: 'processando' | 'idle'
    ultimoProcesso: Maybe<number>
}

type Dispatch =
    | {
          action: 'PROGRESSO'
          data: Maybe<number>
      }
    | {
          action: 'PROCESSANDO'
          data: boolean
      }
    | {
          action: 'ULTIMO_PROCESSO'
          data: Maybe<number>
      }

type Store = {
    state: State
    dispatch: (action: Dispatch, ...actions: Dispatch[]) => void
}

export const useCalculoStore = create<Store>()(
    persist(
        set => ({
            state: {
                progresso: null,
                ultimoProcesso: null,
                state: 'idle' as const,
            },
            dispatch: (...actions) => {
                for (const { action, data } of actions) {
                    switch (action) {
                        case 'PROGRESSO':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    progresso: data,
                                },
                            }))
                            break
                        case 'PROCESSANDO':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    state: data ? 'processando' : 'idle',
                                },
                            }))
                            break
                        case 'ULTIMO_PROCESSO':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    ultimoProcesso: data,
                                },
                            }))
                            break
                    }
                }
            },
        }),
        {
            name: 'calculo-ponto-store',
            partialize: state => ({
                ultimoProcesso: state.state.ultimoProcesso,
            }),
            version: 1,
        },
    ),
)
